import React from "react";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import ReactDatePicker from "react-datepicker";
import { format } from "date-fns";

export default function SidebarContentPublishedAt({ onClose, onSet, id, published_at }) {
  const [publishedAt, setPublishedAt] = React.useState(published_at ? new Date(published_at) : new Date());

  function onDateChange(date) {
    setPublishedAt((prev) => {
      const newDate = new Date(date);
      newDate.setSeconds(prev.getSeconds());
      newDate.setMinutes(prev.getMinutes());
      newDate.setHours(prev.getHours());

      return newDate;
    });
  }

  function onSave() {
    // do stuff
    onSet(id, "published_at", format(publishedAt, "yyyy-MM-dd"));

    onClose();
  }

  return (
    <div className="gstv-ag-grid-sidebar-content">
      <div className="gstv-ag-grid-sidebar-content__section">
        <div className="gstv-ag-grid-sidebar-content__label">Select Publish Date</div>
        <div className="gstv-ag-grid-sidebar-content__group">
          <div className="gw">
            <div className="g g--1-of-1">
              <ReactDatePicker
                selected={new Date(publishedAt)}
                onChange={(date) => onDateChange(date)}
                clearIcon={null}
                dateFormat="yyyy-MM-dd"
                showYearDropdown={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="gstv-ag-grid-sidebar-content__footer">
        <button onClick={onClose} className="gstv-ag-grid-sidebar-content__footer__button">
          <CancelRoundedIcon /> Close
        </button>
        <button onClick={onSave} className="gstv-ag-grid-sidebar-content__footer__button">
          <SaveRoundedIcon /> Save
        </button>
      </div>
    </div>
  );
}
